module.exports = __webpack_public_path__ + "img/game_unselected.edc728b2.png";